const SECTION_RULES = [
  {
    section: 'personal',
    patterns: [
      /first.?name/i,
      /last.?name/i,
      /middle.?name/i,
      /^email$/i,
      /phone/i,
      /dob|date.?of.?birth/i,
      /marital/i,
      /citizenship/i,
      /address|city|state|zip|postal|county|unit/i,
      /ownership|rent|years.?living|months.?living/i,
      /preferred.?contact/i,
      /dependents|canadian.*benefit/i,
      /personal/i,
    ],
  },
  {
    section: 'loan',
    patterns: [
      /loan/i,
      /property/i,
      /purchase|refinance|purpose/i,
      /occupancy|term|program|ltv|cltv|dti/i,
      /subject/i,
    ],
  },
  {
    section: 'employment',
    patterns: [
      /employment|employer|income|salary|bonus|commission|self.?employed|business/i,
    ],
  },
  {
    section: 'assets',
    patterns: [
      /asset|bank|account|cash|fund|stock|bond|retirement|gift/i,
    ],
  },
  {
    section: 'liabilities',
    patterns: [
      /liabilit|debt|credit|card|loan.?payment|alimony|child.?support/i,
    ],
  },
  {
    section: 'reo',
    patterns: [
      /real.?estate|reo|property.?owned|mortgage.?balance/i,
    ],
  },
  {
    section: 'declaration',
    patterns: [/declaration|lawsuit|bankruptcy|foreclosure/i],
  },
  {
    section: 'demographics',
    patterns: [/demographic|ethnicity|race|gender|sex/i],
  },
  {
    section: 'co_borrower',
    patterns: [/co.?borrower|coborrower|spouse/i],
  },
];

export function mapChangedFieldsToSections(changedFields = []) {
  if (!Array.isArray(changedFields) || changedFields.length === 0) {
    return [];
  }

  const sections = new Set();
  changedFields.forEach((field) => {
    const value = String(field || '').trim();
    if (!value) return;
    let matched = false;
    SECTION_RULES.forEach((rule) => {
      if (rule.patterns.some((pattern) => pattern.test(value))) {
        sections.add(rule.section);
        matched = true;
      }
    });
    if (!matched) {
      sections.add('unknown');
    }
  });

  return Array.from(sections);
}

export function normalizeSections(sections = []) {
  if (!Array.isArray(sections)) return [];
  return Array.from(
    new Set(
      sections
        .map((section) => String(section || '').trim())
        .filter(Boolean)
    )
  );
}
